export default __webpack_public_path__ + "static/media/storage.350881ae.svg";